// API Configuration URLs
const backUrl = "https://api.shaku.tech";
// const backUrl = "http://172.17.17.154:8000";
const subUrl = "";
/*const backUrl='';*/
export { backUrl, subUrl };
